export default __webpack_public_path__ + "static/clinicians-exploring-0ae1aeb984d73bff719231b22888aa6d.jpg";